import Vue from 'vue';
import VuejsDialog from 'vuejs-dialog';
import i18n from '@/i18n';

Vue.use(VuejsDialog, {
  html: true,
  loader: false,
  okText: i18n.t('general.actions.ok'),
  cancelText: i18n.t('general.actions.annuler'),
});

export default new VuejsDialog({});
